import { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { useCompany } from "@/config";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const company = useCompany();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#F7F7F5]" data-testid="forgot-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#E5E5E5] p-8 lg:p-10">
        <div className="flex items-center gap-3 mb-6">
          <img src={company.brand.logo} alt={company.shortName} className="h-10 w-10 object-contain" />
          <div className="font-head font-bold text-xl tracking-tighter">{company.shortName}</div>
        </div>
        <div className="eyebrow mb-3">Account recovery</div>
        <h2 className="font-head text-3xl font-bold tracking-tighter mb-2">Forgot password?</h2>
        <p className="text-sm text-neutral-500 mb-8">We'll email you a secure link to reset it. The link expires in 1 hour.</p>

        {sent ? (
          <div className="p-5 border border-emerald-200 bg-emerald-50 text-emerald-800 text-sm" data-testid="forgot-sent">
            <strong>Check your inbox.</strong> If an account exists for <code>{email}</code>, we've just sent a password reset link.
            <div className="mt-4">
              <Link to="/login" className="underline underline-offset-2 text-[#1F4E8C]">Back to sign in</Link>
            </div>
          </div>
        ) : (
          <>
            <div className="space-y-5">
              <div>
                <Label htmlFor="email" className="eyebrow">Email</Label>
                <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none border-[#E5E5E5] h-11" />
              </div>
              <Button type="submit" disabled={busy} data-testid="forgot-submit"
                className="w-full h-12 rounded-none bg-[#FF5500] hover:bg-[#E64D00] text-white font-semibold">
                {busy ? "Sending..." : "Send reset link"}
              </Button>
            </div>
            <div className="mt-6 text-sm">
              <Link to="/login" className="text-neutral-500 hover:text-[#1F4E8C] underline underline-offset-2">← Back to sign in</Link>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
